import type {
  AppchargePaymentElementFieldId,
  AppchargePaymentElementFieldStyles,
} from '@/types/appchargePaymentElement';
import { getEnvVariable } from '@/utils/get-env-variable';

export const APPCHARGE_PAYMENT_ELEMENT_FIELD_URLS: Record<AppchargePaymentElementFieldId, string> = {
  number: getEnvVariable('VITE_NUMBER_FIELD_URL', 'https://fields.dev.appcharge-int.com/number'),
  expiry: getEnvVariable('VITE_EXPIRY_FIELD_URL', 'https://fields.dev.appcharge-int.com/expiry'),
  cvv: getEnvVariable('VITE_CVV_FIELD_URL', 'https://fields.dev.appcharge-int.com/cvv'),
};

export const APPCHARGE_PAYMENT_ELEMENT_FIELD_IDS = {
  NUMBER: 'number',
  EXPIRY: 'expiry',
  CVV: 'cvv',
} as const satisfies Record<string, AppchargePaymentElementFieldId>;

export const APPCHARGE_PAYMENT_ELEMENT_FIELD_STYLES: AppchargePaymentElementFieldStyles = {
  base: {
    // 16px avoids iOS Safari's focus-zoom on tap (anything <16px zooms).
    fontSize: '16px',
    fontWeight: '400',
    color: '#000',
    fontFamily: 'font-sans, sans-serif',
    padding: '12px 8px',
    fontSmoothing: 'antialiased',
  },
  placeholder: {
    color: '#8b8b8b',
  },
  invalid: {
    color: '#dc2626',
  },
};
